import { render, staticRenderFns } from "./TestGrid2.vue?vue&type=template&id=1953507e&scoped=true&"
import script from "./TestGrid2.vue?vue&type=script&lang=js&"
export * from "./TestGrid2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953507e",
  null
  
)

export default component.exports